import countries from 'world-countries';

export interface CountryOption {
  value: string;
  label: string;
  flagImageUrl?: string;
}

/**
 * Generate country options from world-countries package
 * Sorted alphabetically by common name
 * Uses ISO 3-letter codes (cca3) as values for compatibility with User Details and Data Science
 */
export function getCountryOptions(): CountryOption[] {
  return countries
    .map((country) => ({
      label: country.name.common,
      value: country.cca3, // User Details and Data Science made choice to store ISO 3 letter codes
      flagImageUrl: country.flag,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));
}
